module.exports = __webpack_public_path__ + "img/img05.670d96a7.svg";